// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"41":"134a014a","128":"77c88abe","362":"1c12bca0","496":"c0f818c0","681":"c24678b8","794":"4d5e57fd","938":"5f89fae5"}[chunkId] + ".js";
};